/** Initial display mode for multi-image deviations */ export const DEFAULT_MULTI_IMAGE_STAGE = 'carousel';
/** How much of a deviation or attachment need to be scrolled into the
 *  viewport in order to be considered the currently viewed image */ export const SCROLL_MODE_THRESHOLD_FOR_INVIEW = 0.8;
export const BI_CAROUSEL_SECTIONNAME = {
    sectionname: 'multiimage-carousel-artstage'
};
export const BI_SCROLL_SECTIONNAME = {
    sectionname: 'multiimage-scroll-artstage'
};
export const ADDITIONAL_MEDIA_ID_PREFIX = 'attachment-';

//# sourceMappingURL=constants.js.map